import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  standalone: false,
})
export class AuthCallbackComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService) {}
  // very important to return to the application after auth proccess completed
  public checking$ = this.oidcSecurityService.checkAuth();
  ngOnInit() {}
}
